/* Florage Eigen-Attribution v1, Stand 20.09.2026
   Haelt die Herkunft jeder Bestellung fest, unabhaengig von Shopifys
   Session-Mechanik. Gemessen am 20.09.2026 hatten 6 von 8 Bestellungen
   der letzten 28 Tage keinen zugeordneten Besuch.
   Schluessel mit fuehrendem Unterstrich sind im Checkout unsichtbar. */
(function () {
  'use strict';
  var KEY = 'fl_attr_v1';
  var FIRST_DAYS = 90;
  var CLICK_IDS = ['gclid', 'gbraid', 'wbraid', 'msclkid', 'fbclid', 'ttclid'];
  var UTMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

  function readStore() {
    try { var v = localStorage.getItem(KEY); if (v) return JSON.parse(v); } catch (e) {}
    try {
      var m = document.cookie.match(/(?:^|;\s*)fl_attr_v1=([^;]+)/);
      if (m) return JSON.parse(decodeURIComponent(m[1]));
    } catch (e) {}
    return null;
  }

  function writeStore(obj) {
    var s = JSON.stringify(obj);
    try { localStorage.setItem(KEY, s); } catch (e) {}
    try {
      document.cookie = 'fl_attr_v1=' + encodeURIComponent(s) +
        ';path=/;max-age=' + (FIRST_DAYS * 86400) + ';SameSite=Lax';
    } catch (e) {}
  }

  function currentTouch() {
    var q = new URLSearchParams(location.search);
    var t = { landing: location.pathname, at: new Date().toISOString() };
    UTMS.forEach(function (k) { if (q.get(k)) t[k] = q.get(k); });
    for (var i = 0; i < CLICK_IDS.length; i++) {
      if (q.get(CLICK_IDS[i])) { t.click_id = CLICK_IDS[i] + ':' + q.get(CLICK_IDS[i]); break; }
    }
    var ref = document.referrer || '';
    if (ref) {
      try {
        var rh = new URL(ref).hostname.replace(/^www\./, '');
        if (rh !== location.hostname.replace(/^www\./, '')) t.referrer = rh;
      } catch (e) {}
    }
    if (t.click_id && /^gclid|^gbraid|^wbraid/.test(t.click_id)) t.channel = 'google-ads';
    else if (t.utm_medium) t.channel = (t.utm_source || 'unbekannt') + ' / ' + t.utm_medium;
    else if (t.utm_source) t.channel = t.utm_source;
    else if (t.referrer) {
      if (/google\./.test(t.referrer)) t.channel = 'google-organisch';
      else if (/bing\.|duckduckgo|ecosia|yahoo/.test(t.referrer)) t.channel = 'suche-sonstige';
      else if (/chatgpt|openai|perplexity|claude\.ai|copilot|gemini/.test(t.referrer)) t.channel = 'ki-assistent';
      else if (/instagram|facebook|pinterest|tiktok|youtube/.test(t.referrer)) t.channel = 'social';
      else t.channel = 'verweis:' + t.referrer;
    } else t.channel = 'direkt';
    return t;
  }

  function updateStore() {
    var now = currentTouch();
    var st = readStore();
    var informativ = now.channel !== 'direkt';
    if (!st) { st = { first: now, last: now, touches: 1 }; }
    else {
      st.touches = (st.touches || 1) + 1;
      if (informativ) st.last = now;
      if (!st.first) st.first = now;
    }
    writeStore(st);
    return st;
  }

  function attrsFrom(st) {
    var f = st.first || {}, l = st.last || {};
    return {
      '_fl_channel': l.channel || f.channel || 'direkt',
      '_fl_first_channel': f.channel || '',
      '_fl_first_landing': f.landing || '',
      '_fl_first_at': f.at || '',
      '_fl_last_landing': l.landing || '',
      '_fl_referrer': l.referrer || f.referrer || '',
      '_fl_campaign': l.utm_campaign || f.utm_campaign || '',
      '_fl_click_id': l.click_id || f.click_id || '',
      '_fl_touches': String(st.touches || 1)
    };
  }

  var lastWritten = '';

  function syncCart(force) {
    var st = readStore();
    if (!st) return;
    var attrs = attrsFrom(st);
    var sig = JSON.stringify(attrs);
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.item_count) return;
        var have = cart.attributes || {};
        if (!force && have._fl_channel === attrs._fl_channel && sig === lastWritten) return;
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: attrs })
        }).then(function () { lastWritten = sig; });
      })
      .catch(function () {});
  }

  updateStore();
  syncCart(false);

  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(function () { setTimeout(function () { syncCart(true); }, 120); }).catch(function () {});
      }
      return p;
    };
  }

  var origSend = XMLHttpRequest.prototype.send;
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) { this.__flUrl = u || ''; return origOpen.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var self = this;
    if (/\/cart\/(add|change|update)/.test(self.__flUrl || '')) {
      self.addEventListener('load', function () { setTimeout(function () { syncCart(true); }, 120); });
    }
    return origSend.apply(this, arguments);
  };

  document.addEventListener('click', function (ev) {
    var el = ev.target && ev.target.closest && ev.target.closest('a[href*="/checkout"], [name="checkout"], form[action*="/checkout"] button');
    if (el) syncCart(true);
  }, true);

  window.flAttribution = { read: readStore, sync: function () { syncCart(true); }, attrs: function () { return attrsFrom(readStore() || {}); } };
})();